module.exports = __webpack_public_path__ + "static/feature-shot-3-29f0aa59d93871172bcc26e0c8657ab2.jpg";